<template>
  <PopUp :showPopUp="showPopUp" :lockScroll="false" :datas="contractData" @closed="popClosed" teleport="body" class="serviceDealPopBox">
    <p v-if="isShowMark" class="themeRed preViewMark">{{ markMessage }}</p>
    <van-skeleton title :row="3" :loading="!isShowServiceDealDetail">
      <ServiceDeal class="serviceDealSection" :datas="contractData?.contents" />
    </van-skeleton>
    <div class="loadingBox">
      <template v-for="imgSrc in notificationImg" :key="imgSrc">
        <van-image :src="imgSrc" @load="imgLoadFinished">
          <template v-slot:error><p>加载失败</p></template>
          <template v-slot:loading> <van-loading type="spinner" size="20" /> </template>
        </van-image>
      </template>
    </div>
  </PopUp>
</template>
<script>
import { reactive, toRefs, computed, watch } from 'vue'
import { getContractContentCommonFn } from '@/assets/js/contract.js'
import PopUp from '@/components/common/PopUp'
import ServiceDeal from '@/components/common/serviceDeal'

export default {
  props: ['datas', 'showPopUp'],
  components: {
    PopUp,
    ServiceDeal
  },
  setup(props) {
    let { datas, showPopUp } = toRefs(props)
    const state = reactive({
      showPopUp,
      datas,
      contractData: {},
      isShowServiceDealDetail: false,
      imgLoadFinishedNum: 0
    })
    const popClosed = () => {
      state.contractData = {}
      state.imgLoadFinishedNum = 0
      state.isShowServiceDealDetail = false
    }

    const notificationImg = computed(() => state.contractData?.option?.notificationFile || [])
    const isShowMark = computed(() => state.contractData?.option?.isShowMark || false)
    const markMessage = computed(() => state.contractData?.option?.markMessage || '')

    const imgLoadFinished = () => {
      console.log('imgLoadFinished---------------')
      // state.isShowServiceDealDetail = true
      state.imgLoadFinishedNum += 1
    }
    watch(
      () => state.imgLoadFinishedNum,
      num => {
        if (num === notificationImg.value?.length && num > 0) {
          state.isShowServiceDealDetail = true
        }
      }
    )
    watch(
      () => state.showPopUp,
      () => {
        let contractData = {
          title: state.datas.notificationName
        }
        console.log('state.datas', state)
        contractData.option = state.datas
        contractData.contents = getContractContentCommonFn(state.datas)
        state.contractData = contractData
        state.imgLoadFinishedNum = 0
      }
    )
      console.log('contractData', state.contractData)
    return {
      ...toRefs(state),
      popClosed,
      imgLoadFinished,
      notificationImg,
      isShowMark,
      markMessage
      // contractData
    }
  }
}
</script>
<style lang="scss" scoped>
.preViewMark {
  text-align: right;
}
.serviceDealPopBox .van-action-sheet__content {
  .serviceDealSection {
    padding-bottom: 1px !important;
  }
  .loadingBox {
    padding-bottom: calc(6px + constant(safe-area-inset-bottom));
    padding-bottom: calc(6px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    font-size: 0;
    // border: 1px solid red;
  }
  .van-image__error {
    display: block;
    position: relative !important;
  }
}
</style>
